import React from "react";

// SVG Import
import SVGComponent from "../../SVGComponent";
import TickerAnimation from "../../TickerAnimation";

/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("normal" | "outline")} Variant
 * @typedef {("white" | "black")} HoverOption
 *
 * @param {Object} props
 * @param {String} props.txtChip - Default string to show
 * @param {String} props.enabledTextColor - Color of text when chip is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when chip is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when chip is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when chip is disabled (var only)
 * @param {String?} props.outLineColor - Color of chip outline (border color) (var only)
 * @param {Object} props.chipRef - Chip ref (optional)
 * @param {boolean} props.fullWidthRequired - Full width required (optional)
 * @param {Variant} props.variant - Chip style variant ("normal" | "outline")
 * @param {String?} props.icon - Optional trailing icon
 * @param {String?} props.iconColor - Optional trailing icon color
 * @param {boolean} props.disableIcon - Disable only the icon (optional)
 *
 * @returns {JSX.Element}
 */
const Chips = ({
  txtChip,
  handleFunction,
  handleFunctionBtn,
  enabledTextColor,
  enabledBgColor,
  disabledBgColor,
  outLineColor,
  chipRef,
  fullWidthRequired,
  variant = "normal",
  icon,
  iconColor,
  hoverOption,
  hoverOptionBtn,
  disableIcon = false,
  isDisabled = false,
  isTickerRequired,
  inActiveVariantNeeded,
}) => {
  const iconHoverClass = !disableIcon
    ? hoverOption === "white"
      ? "hover:opacity-light-opacity"
      : "hover:opacity-dark-opacity"
    : "";

  const rightPaddingClass = icon ? "pr-padding-sm" : "pr-padding-button-l";
  const isChipClickable = !!handleFunctionBtn;

  return (
    <div
      ref={chipRef || null}
      className={`flex items-center justify-center gap-gap-button-s py-padding-button-m pl-padding-button-l ${rightPaddingClass} ${
        fullWidthRequired ? "w-width-full" : "w-auto"
      } h-auto rounded-border-radius-md  z-z-index-base relative

 ${
   isChipClickable
     ? isDisabled
       ? `cursor-not-allowed ${
           inActiveVariantNeeded ? "" : "opacity-light-opacity"
         }`
       : `cursor-pointer ${
           hoverOptionBtn === "white"
             ? "global-hover-white"
             : hoverOptionBtn === "black"
               ? "global-hover-black"
               : ""
         }`
     : ""
 }
      
     `}
      style={{
        border: outLineColor ? `var(--border) solid ${outLineColor}` : "",
        backgroundColor: enabledBgColor?.toString(),
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (!isDisabled && handleFunctionBtn && !handleFunction)
          handleFunctionBtn(e);
      }}
    >
      {isTickerRequired ? (
        <span
          className="text-font-xs font-sans font-normal flex-shrink-0 whitespace-nowrap max-w-chips-max-width"
          style={{ color: enabledTextColor }}
        >
          <TickerAnimation text={txtChip} />
        </span>
      ) : (
        <span
          className="text-font-xs font-sans font-normal flex-shrink-0 whitespace-nowrap"
          style={{ color: enabledTextColor }}
        >
          {txtChip}
        </span>
      )}

      {icon && (
        <div
          className={`flex items-center justify-center ${
            disableIcon
              ? "cursor-not-allowed opacity-light-opacity"
              : handleFunctionBtn
                ? ""
                : "cursor-pointer"
          } ${handleFunctionBtn ? "" : iconHoverClass}`}
          onClick={(e) => {
            e.stopPropagation();
            if (disableIcon) return;

            if (handleFunction && !handleFunctionBtn) {
              handleFunction(e);
              return;
            }

            if (!isDisabled && handleFunctionBtn && !handleFunction) {
              handleFunctionBtn(e);
            }
          }}
        >
          <SVGComponent
            url={icon}
            iconColor={iconColor}
            alt="ChipIcon"
            height="var(--icon-sm)"
            width="var(--icon-sm)"
          />
        </div>
      )}
    </div>
  );
};

export default Chips;
